import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import LocationOffOutlinedIcon from '@mui/icons-material/LocationOffOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Box } from '@mui/material';

import { FEED_BACK, RED } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';
import { epochToTimeInReadableFormat } from '../../../../utils';

const GpsStatus = ({ onsite, timestamp, showTime = false, card = false }) => {
  const label = LanguageConverter(onsite ? 'jobOrder.gps.onSite' : 'jobOrder.gps.offSite');
  const time = showTime ? epochToTimeInReadableFormat(timestamp) : '';
  const onSiteColor = card ? FEED_BACK.GREEN_80 : FEED_BACK.GREEN_70;
  const offSiteColor = card ? RED[80] : RED[70];
  const color = onsite ? onSiteColor : offSiteColor;
  const iconSize = card ? 10 : 14;

  return (
    <Box
      component="span"
      data-testid="gps-status"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: card ? '2px' : '4px',
        color,
        fontFamily: card ? PRIMARY_FONT[500] : PRIMARY_FONT[700],
        fontSize: card ? '10px' : '12px',
        lineHeight: card ? '12px' : '14px',
        whiteSpace: 'nowrap',
      }}
    >
      {onsite ? (
        <LocationOnOutlinedIcon sx={{ fontSize: iconSize, color: 'inherit' }} />
      ) : (
        <LocationOffOutlinedIcon sx={{ fontSize: iconSize, color: 'inherit' }} />
      )}
      <span>
        {label}
        {time ? ` • ${time}` : ''}
      </span>
    </Box>
  );
};

GpsStatus.propTypes = {
  onsite: PropTypes.bool,
  timestamp: PropTypes.number,
  showTime: PropTypes.bool,
  card: PropTypes.bool,
};

export default GpsStatus;
